import type { DetailedCatalystInsight } from '@api/api/catalyst-insights';
import { getEntityTagFromSnake } from '@helpers/utils/entity/entity';

interface CatalystHeaderIdentifierProps {
  catalystInsight: DetailedCatalystInsight;
  identifier: string;
  isCompanyCatalyst?: boolean;
}

interface CatalystHeaderIdentifiers {
  entityTag: string;
  themeId?: string;
}

export const getCatalystHeaderIdentifiers = ({
  catalystInsight,
  identifier,
  isCompanyCatalyst,
}: CatalystHeaderIdentifierProps): CatalystHeaderIdentifiers => {
  if (isCompanyCatalyst) {
    return { entityTag: identifier };
  }

  return {
    entityTag: getEntityTagFromSnake(catalystInsight.snakes[0]),
    themeId: identifier,
  };
};
